// in src/posts.js
import React, { useState } from 'react';

import { useDataProvider } from 'react-admin';import {useHistory} from 'react-router-dom';
import { Link } from 'react-router-dom';

import { List as MuiList } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import EventNoteIcon from '@mui/icons-material/EventNote';
import SettingsIcon from '@mui/icons-material/Settings';

import { useTranslate  } from '../common/language';

import Typography from '@mui/material/Typography';



import MobileFriendlyIcon from '@material-ui/icons/MobileFriendly';
import EventSeatIcon from '@mui/icons-material/EventSeat';


import Box from '@material-ui/core/Box';


export const SettingsTickets = ( props ) => {
    
  var translate = useTranslate();
  const history = useHistory();
  const dataProvider = useDataProvider();
  const [info, setInfo] = useState();
                    
  const isOwner = ['OWNER'].includes(localStorage.getItem('permissions_groups'));
  
  return (
        
    <>
      <br/>
      <Typography variant="h5" className="grey8" align="center">
        {translate('tickets.title')}              
      </Typography>

      <Box sx={{ width: '100%', maxWidth: 500, bgcolor: 'background.paper', padding: '25px' }} className="settings_box" >
        <MuiList>
            <ListItem>
              <ListItemButton component={Link} to={{ pathname: 'settings-tickets-general' }}>
                <ListItemIcon>
                  <SettingsIcon />
                </ListItemIcon>
                <ListItemText primary={translate('tickets_general.title')} secondary={translate('tickets_general.desc')} />
              </ListItemButton>
            </ListItem>

            <ListItem>
              <ListItemButton component={Link} to={{ pathname: 'settings-tickets-reservations' }}>
                <ListItemIcon>
                  <EventNoteIcon />
                </ListItemIcon>
                <ListItemText primary={translate('tickets_reservations.title')} secondary={translate('tickets_reservations.desc')} />
              </ListItemButton>
            </ListItem>

            <ListItem>
              <ListItemButton component={Link} to={{ pathname: 'settings-tickets-groups' }}>
                <ListItemIcon>
                  <GroupWorkIcon />
                </ListItemIcon>
                <ListItemText primary={translate('tickets_groups.title')} secondary={ translate('tickets_groups.desc') }  />
              </ListItemButton>
            </ListItem>

            <ListItem>
              <ListItemButton component={Link} to={{ pathname: '/settings-tickets-discounts' }}>
                <ListItemIcon><LocalOfferIcon /></ListItemIcon>
                <ListItemText primary={translate('tickets_discounts.title')} secondary={translate('tickets_discounts.desc')} />
              </ListItemButton>
            </ListItem>
            
            <ListItem>
              <ListItemButton component={Link} to={{ pathname: 'settings-tickets-maps' }}>
                <ListItemIcon>
                  <EventSeatIcon />
                </ListItemIcon>
                <ListItemText primary={translate('tickets_maps.title')} secondary={ translate('tickets_maps.desc') }  />
              </ListItemButton>
            </ListItem>
            
            <ListItem>
              <ListItemButton component={Link} to={{ pathname: 'settings-events-subscriptions' }}>
                <ListItemIcon>
                  <CardMembershipIcon />
                </ListItemIcon>
                <ListItemText primary={translate('events_subscriptions.title')} secondary={ translate('events_subscriptions.desc') }  />
              </ListItemButton>
            </ListItem>
            
            <ListItem>
              <ListItemButton component={Link} to={{ pathname: 'settings-tickets-validators' }}>
                <ListItemIcon>
                  <MobileFriendlyIcon />
                </ListItemIcon>
                <ListItemText primary={translate('tickets_validators.title')} secondary={ translate('tickets_validators.desc') }  />
              </ListItemButton>
            </ListItem>
            

            { isOwner ? 
            <ListItem>
            <ListItemButton component={Link} to={{ pathname: '/settings-tickets-users' }} >
              <ListItemIcon>
                <SupervisorAccountIcon />
              </ListItemIcon>
              <ListItemText primary={translate('settings.tickets_users')} secondary={translate('settings.tickets_users_desc')}/>
            </ListItemButton>
            </ListItem>
            : null }
            
        </MuiList>
      </Box>
    </>
    
  );
  
};

